export default __webpack_public_path__ + "images/bg-c9c13073359faec8e076a738146b8f66.svg";